export default "__VITE_ASSET__BvDE3O7A__"